// extracted by mini-css-extract-plugin
module.exports = {"main":"MainLayout_main__-yjf0","wrp":"MainLayout_wrp__2ASwq"};